"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDate = exports.isComparable = exports.isIterable = void 0;
exports.isIterable = (value) => {
    if (value == null) {
        return false;
    }
    const itr = value;
    if (itr[Symbol.iterator] == null) {
        return false;
    }
    return true;
};
exports.isComparable = (object) => {
    const toString = Object.prototype.toString;
    const cast = object;
    return cast.compare != null && toString.call(cast.compare).endsWith('Function]');
};
exports.isDate = (value) => {
    const toString = Object.prototype.toString;
    return toString.call(value).endsWith('Date]');
};
